module.exports = __webpack_public_path__ + "static/img/premialy.a32be48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/premialy.png
// module id = 208
// module chunks = 10